/** The motifs the mission wizard offers, in the order the step lists them. */
export const MISSION_MOTIFS = [
    {
        type: "1",
        title: "Accroissement temporaire d'activité",
        modal: "cM_accroissement",
    },
    {
        type: "2",
        title: "En attente de recrutement",
        modal: "cM_attRecrutement",
    },
    {
        type: "3",
        title: "Remplacement d'un salarié absent",
        modal: "cM_remplacement",
    },
    {
        type: "5",
        title: "Emploi à caractère saisonnier",
        modal: "cM_saisonnier",
    },
    {
        type: "4",
        title: "Contrat temporaire d'usage",
        modal: "cM_temporaire",
    },
];

export const getMissionMotifTitle = (type) =>
    MISSION_MOTIFS.find((motif) => motif.type === String(type))?.title || "";

/** What the chosen motif adds: who is replaced, since when, or the reason itself. */
export const getMissionMotifDetail = (motif, formatDate) =>
    [
        [motif?.prenom, motif?.name].filter(Boolean).join(" "),
        motif?.poste,
        motif?.date && formatDate ? formatDate(motif.date) : "",
        motif?.message,
    ]
        .filter((part) => typeof part === "string" && part.trim() !== "")
        .join(" — ");
